import { lazy } from 'react'

/** Code-split entry: three.js and the scene only load after the app shell paints. */
export const LazyImmersiveStage = lazy(() =>
  import('./ImmersiveStage').then(module => ({ default: module.ImmersiveStage }))
)
